<template>
  <div id="app">
    <pageHeader />
    <div class="page-wrap">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" />
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </div>
    <footer>
      <div class="footer-box">
        <div class="footer">
          <div class="info">
            <a href="">
              <img src="@/assets/image/Logo-2@2x.png" class="logo" alt="" />
            </a>
          </div>
          <div class="web-info">
            <a class="item-tab tab-active" href="javascript:;">友情链接</a>
            <!-- <router-link to="/myArticle?id=10001">
              <span class="item-tab">隐私政策</span>
            </router-link> -->
            <a
              class="item-tab"
              href="http://www.gdbs.gov.cn/"
              title="广东省政府网上办事大厅"
              target="blank"
              >广东省政府网上办事大厅</a
            >
            <a
              class="item-tab"
              href="http://www.gddrc.gov.cn/"
              title="广东省发展与改革委员会"
              target="blank"
              >广东省发展与改革委员会</a
            >
            <a
              class="item-tab"
              href="http://www.gdggzy.org.cn/"
              title="广东省公共资源交易中心"
              target="blank"
              >广东省公共资源交易中心
            </a>
            <a
              class="item-tab"
              href="http://www.ctba.org.cn/"
              title="中国招投标协会"
              target="blank"
              >中国招投标协会</a
            >
            <a
              class="item-tab"
              href="http://www.ccgp.gov.cn/"
              title="中国政府采购网"
              target="blank"
              >中国政府采购网</a
            >
            <a
              class="item-tab"
              href="http://www.cspea.org.cn/"
              title="中国产权网"
              target="blank"
              >中国产权网</a
            >
          </div>
          <!-- <div class="service">
            <p class="label-title">联系我们</p>
            <img src="@/assets/image/code.png" class="item" alt="" />
            <img src="@/assets/image/code1.png" alt="" />
          </div> -->
        </div>
      </div>
      <div class="footer-text">
        <p class="number">
          主办单位：广东省公共资源交易联合会 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          粤ICP备17159025号-1
        </p>
        <p>
          电子邮箱：gdggzyjylhh@163.com&nbsp;&nbsp;&nbsp;&nbsp;
          联系电话：020-37500416 &nbsp;&nbsp;&nbsp;&nbsp;
          办公地址：广州市越秀区东风中路302号煤炭大厦8楼811室
        </p>
        <p>
          广东省公共资源交易联合会版权所有&nbsp;&nbsp;&nbsp;&nbsp;
          主体备案号：粤ICP备17159025号&nbsp;&nbsp; |&nbsp;&nbsp;
          <img src="https://www.gdprea.com/images/bah.png" alt="" /> 粤公网安备
          44010402001175号
        </p>
        <p>技术支持：广州华数云计算有限公司</p>
        <!-- <p class="company">
          Copyright © 2023 . All Rights Reserved. 广州华数云计算有限公司
          监督举报邮箱：tech@huashuyun.net
        </p> -->
      </div>
    </footer>
  </div>
</template>

<script>
import pageHeader from "@/components/pageHeader";
export default {
  components: {
    pageHeader,
  },
};
</script>

<style lang="less">
@import "./assets/css/reset.less";

html,
body {
  height: 100%;
  margin: 0;
  background-color: #ffffff;
  min-width: 1440px;
  color: #030303;
}

#app {
  min-height: 100%;
  display: flex;
  flex-direction: column;
}

/*设置宽度,轨道颜色*/
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  background: #c6c6c6;
  /*可以设置轨道颜色*/
  padding-right: 2px;
}

/*滚动条*/
::-webkit-scrollbar-thumb {
  background: #e6e6e6;
  border-radius: 10px;
}

.line-clamp-1 {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.line-clamp-2 {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
.line-clamp-3 {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
}

.noData {
  padding-top: 75px;
  color: #5e6272;
  text-align: center;
  .emptyimg {
    width: 175px;
  }
  .empty-text {
    text-align: center;
    font-size: 12px;
    line-height: 20px;
    margin-top: 2px;
  }
}
.in-label {
  display: flex;
  align-items: center;
  font-size: 24px;
  font-weight: 600;
  color: #0b1d28;
  margin-bottom: 40px;
  .icon-tri {
    width: 24px;
    height: 24px;
  }
}
// .page-wrap {
//  padding-top: 132px;
// }
.page-content {
  width: 1440px;
  margin: 0 auto;
}
footer {
  position: relative;
  z-index: 99;
  margin-top: auto;
  .footer-box {
    padding: 24px 0;
    background: #f1f2f3;
    box-sizing: border-box;

    .footer {
      display: flex;
      align-items: center;
      width: 1440px;
      margin: auto;

      .info {
        .logo {
          width: 257px;
          height: 35px;
        }
      }
      .web-info {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-left: 140px;
        .item-tab {
          font-size: 14px;
          font-weight: 600;
          color: #494b4e;
          // margin-right: 51px;
        }
        .item-tab:hover {
          color: #00b5a3;
          font-weight: 600;
        }

        .tab-active {
          color: #00b5a3;
          font-weight: 600;
        }
      }
      .label-title {
        font-size: 13px;
        font-weight: 500;
        color: #0b1d28;
        padding-bottom: 22px;
      }
      .service {
        width: 370px;
        height: 158px;
        background: #eaebeb;
        padding: 20px;

        img {
          width: 70px;

          &.item {
            margin-right: 32px;
          }
        }
      }
      .download {
        a {
          width: 256px;
          height: 75px;
          background: #eaebeb;
          border-radius: 4px;
          padding-left: 86px;
          display: flex;
          align-items: center;
          font-size: 18px;
          font-weight: 600;
          color: #0b1d28;
          background-repeat: no-repeat;
          background-size: 40px;
          background-position: left 30px center;
          background-image: url("@/assets/image/Android-icon@2x.png");
          box-sizing: border-box;
          &:first-child {
            background-image: url("@/assets/image/apple-icon@2x.png");
            margin-bottom: 8px;
          }
        }
        a:first-child:hover {
          background-image: url("@/assets/image/apple-icon@2x-active.png");
        }
        a:hover {
          color: #00b5a3;
          background-image: url("@/assets/image/Android-icon@2x-active.png");
        }
      }
    }
  }
  .footer-text {
    text-align: center;
    // height: 112px;
    background: #eaebeb;
    padding: 28px 0;
    box-sizing: border-box;
    color: #666;
    p {
      font-size: 14px;
      line-height: 24px;
    }
    .company {
      font-size: 12px;
      line-height: 24px;
    }
  }
}
.el-button--primary {
  background: #00b5a3 !important;
  border-color: #00b5a3 !important;
}
</style>
